"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = isElementContainsFocus;

var _helpers = require("@paprika/helpers");

function isElementContainsFocus(element) {
  if (!element) return false;
  var activeElement = (0, _helpers.getActiveElement)();
  if (activeElement === element) return true;
  return element.contains(activeElement);
}
//# sourceMappingURL=isElementContainsFocus.js.map